<template>
  <div class="community-list-page">
    <div class="page-header">
      <h1><i class="el-icon-chat-dot-square"></i> 社区广场</h1>
      <p>发现更多精彩内容</p>
    </div>

    <div class="community-grid" v-loading="loading">
      <div
        v-for="category in categoryList"
        :key="category.id"
        class="community-card"
        :style="{ background: getGradient(category.id) }"
        @click="goCommunity(category.id)"
      >
        <div class="community-icon">
          <i :class="category.icon || 'el-icon-folder'"></i>
        </div>
        <h3 class="community-name">{{ category.categoryName }}</h3>
        <p class="community-count">
          <i class="el-icon-document"></i>
          <span>{{ formatPostCount(category.postCount) }} 篇帖子</span>
        </p>
        <p class="community-desc">{{ category.description || '暂无描述' }}</p>
      </div>
    </div>

    <el-empty v-if="categoryList.length === 0 && !loading" description="暂无社区"></el-empty>
  </div>
</template>

<script>
export default {
  name: 'CommunityList',
  data() {
    return {
      categoryList: [],
      loading: false
    };
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    async getCategoryList() {
      this.loading = true;
      try {
        const response = await this.$axios({
          method: 'post',
          url: '/category/categoryTree',
          data: {}
        });
        
        if (response.code === '200' && response.data) {
          // 获取一级分类
          this.categoryList = response.data.children || [];
          // 为每个分类获取帖子数量（包含子分类）
          for (const category of this.categoryList) {
            const categoryIds = this.collectAllCategoryIds(category);
            const postCount = await this.getPostCountByCategories(categoryIds);
            category.postCount = postCount;
          }
        }
      } catch (error) {
        console.error('获取社区列表失败:', error);
        this.$message.error('获取社区列表失败');
      } finally {
        this.loading = false;
      }
    },
    collectAllCategoryIds(category) {
      const ids = [category.id];
      if (category.children && category.children.length > 0) {
        for (const child of category.children) {
          const subIds = this.collectAllCategoryIds(child);
          ids.push(...subIds);
        }
      }
      return ids;
    },
    async getPostCountByCategories(categoryIds) {
      try {
        const response = await this.$axios({
          method: 'post',
          url: '/doc/queryUserDocListByCategories',
          data: {
            pageNum: 1,
            pageSize: 1,
            categoryIds: categoryIds
          }
        });
        
        if (response.code === '200' || response.code === 200) {
          return response.data.total || 0;
        }
      } catch (error) {
        console.error('获取帖子数失败:', error);
      }
      return 0;
    },
    formatPostCount(count) {
      if (!count) return 0;
      if (count >= 10000) {
        return (count / 10000).toFixed(1) + 'w';
      } else if (count >= 1000) {
        return (count / 1000).toFixed(1) + 'k';
      }
      return count;
    },
    getGradient(id) {
      const gradients = [
        'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
        'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
        'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)'
      ];
      return gradients[(id - 1) % gradients.length] || gradients[0];
    },
    goCommunity(id) {
      this.$router.push({ name: 'Community', params: { id } });
    }
  }
};
</script>

<style lang="less" scoped>
.community-list-page {
  min-height: calc(100vh - 64px);
  margin-top: 64px;
  padding: 40px 24px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.page-header {
  text-align: center;
  margin-bottom: 40px;

  h1 {
    margin: 0 0 10px 0;
    font-size: 36px;
    font-weight: 700;
    color: #333;

    i {
      margin-right: 12px;
      color: #667eea;
    }
  }

  p {
    margin: 0;
    font-size: 16px;
    color: #666;
  }
}

.community-grid {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;

  .community-card {
    padding: 30px;
    border-radius: 16px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 16px 40px rgba(0, 0, 0, 0.15);
    }

    .community-icon {
      width: 60px;
      height: 60px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;

      i {
        font-size: 30px;
      }
    }

    .community-name {
      margin: 0 0 12px 0;
      font-size: 22px;
      font-weight: 700;
    }

    .community-count {
      margin: 0 0 12px 0;
      font-size: 14px;
      opacity: 0.9;
      display: flex;
      align-items: center;
      gap: 6px;

      i {
        font-size: 16px;
      }
    }

    .community-desc {
      margin: 0;
      font-size: 13px;
      opacity: 0.8;
      line-height: 1.6;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}

@media (max-width: 768px) {
  .community-grid {
    grid-template-columns: 1fr;
  }
}
</style>
